import { useContext, useState } from 'react';
import AdminContext, { EmailChange, initialEmailChangeState } from 'src/context/admin';
import EnrollmentContext from 'src/context/enrollment';
import UserContext from 'src/context/user';

interface Props {
  children: React.ReactNode;
}

export function AdminProvider({ children }: Props) {
  const { refetch: refetchUser } = useContext(UserContext);
  const { refetch: refetchEnrollment } = useContext(EnrollmentContext);
  const [studentNumber, setStudentNumber] = useState<string>('');
  const [reason, setReason] = useState<string>('');
  const [isImpersonating, setIsImpersonating] = useState<boolean>(false);
  const [emailChange, setEmailChange] = useState<EmailChange>(initialEmailChangeState);

  const context = {
    refetchUser,
    refetchEnrollment,
    setIsImpersonating,
    setStudentNumber,
    setReason,
    studentNumber,
    reason,
    isImpersonating,
    emailChange,
    setEmailChange,
  };

  return <AdminContext.Provider value={context}>{children}</AdminContext.Provider>;
}
